// src/App/Animations/HeroAnimation.js
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(SplitText);

import Animation from "./Animation.js";

export default class ProjectsAnimation extends Animation {
  constructor(element) {
    super(element);
  }

  setInitialState() {
    this.projectsTitles = this.element.querySelectorAll(".projects__title");
    this.projectsTags = this.element.querySelectorAll(".projects__tag");
    this.projectsText = this.element.querySelectorAll('.projects__text')

    gsap.set(this.projectsTitles, { yPercent: 105 });
    gsap.set(this.projectsTags, { yPercent: 100 });
  }

  createTimeline() {
    const tl = gsap.timeline({ paused: true });

    tl.to(this.projectsTitles, {
      // autoAlpha: 1,
      yPercent: 0,
      duration: 1,
      stagger: 0.1,
      ease: "power3.out",
    }).to(
      this.projectsTags,
      {
        // opacity: 1,
        yPercent: 0,
        stagger: 0.15,
        ease: "power3.out",
      },
      "<+0.5"
    );

    return tl;
  }
}
